import React, {Component} from "react";
import {List} from "immutable";
import {cx} from "../lib/ClassSet";
import "./SectionMenu.css";

class SectionMenu extends Component {

  constructor(props) {
    super(props);
    this.handleItemClick = this.handleItemClick.bind(this);
  }

  render() {
    let items = this.props.items.map(x => {
      return <Item 
              key={x.get("id")} 
              id={x.get("id")} 
              label={x.get("label")} 
              selected={x.get("id") === this.props.selectedId}
              onClick={() => this.handleItemClick(x.get("id"))}
              />
    })
    return (
      <div className="SectionMenu">
        {items}
      </div>
    )
  }

  handleItemClick(id) {
    if (this.props.selectedId === id) return;
    this.props.onChange(id);
  }

}

const Item = (props) => {

  let classes = cx({
    "item": true,
    "u-selected": props.selected
  })
  return (
    <div className={classes} onClick={props.onClick}>{props.label}</div>
  )
}

SectionMenu.defaultProps = {
  items: List(),
  selectedId: ""
}

export default SectionMenu;